module.exports = __webpack_public_path__ + "img/Background_red.f1b0216e.png";